module.exports = __webpack_public_path__ + "img/PriceSelectOff.de302e39.png";